import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 3 — Benefits Administration shell. Sidebar nav + <Outlet/>,
 * mirroring the CompensationShell layout (reuses the `hr-shell` CSS classes).
 */

const NAV = [
  { to: '/benefits/plans', label: 'Plan Catalog', testid: 'benefits-nav-plans' },
  { to: '/benefits/eligibility', label: 'Eligibility Rules', testid: 'benefits-nav-eligibility' },
  { to: '/benefits/windows', label: 'Enrollment Windows', testid: 'benefits-nav-windows' },
  { to: '/benefits/enroll', label: 'Enroll', testid: 'benefits-nav-enroll' },
  { to: '/benefits/dependents', label: 'Dependents', testid: 'benefits-nav-dependents' },
  { to: '/benefits/life-events', label: 'Life Events', testid: 'benefits-nav-life-events' },
  { to: '/benefits/deductions', label: 'Deduction Preview', testid: 'benefits-nav-deductions' },
];

export default function BenefitsShell() {
  return (
    <div className="hr-shell" data-testid="benefits-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Benefits</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink
                  to={n.to}
                  data-testid={n.testid}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
